import { useTranslation } from 'react-i18next';
import { AnimatedSection } from '../../../components/AnimatedSection';

export default function ContactHero() {
  const { t } = useTranslation();

  const badges = [
    { icon: 'ri-time-line', labelKey: 'contact_badge1_label', subKey: 'contact_badge1_sub' },
    { icon: 'ri-shield-check-line', labelKey: 'contact_badge2_label', subKey: 'contact_badge2_sub' },
    { icon: 'ri-lock-2-line', labelKey: 'contact_badge3_label', subKey: 'contact_badge3_sub' },
  ];

  return (
    <section className="relative pt-32 pb-16 bg-slate-950 overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{backgroundImage: 'radial-gradient(circle at 20% 50%, #00C9A7 0%, transparent 50%), radial-gradient(circle at 80% 50%, #1A56DB 0%, transparent 50%)'}}></div>
      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <AnimatedSection animation="fade-in">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-6">
            <i className="ri-message-3-line text-cyan-400 text-sm"></i>
            <span className="text-cyan-400 text-sm font-medium">{t('contact_badge')}</span>
          </div>
          <h1 className="text-5xl font-bold text-white mb-5 leading-tight">
            {t('contact_hero_title1')}<br />
            <span className="text-cyan-400">{t('contact_hero_title2')}</span>
          </h1>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto mb-10">
            {t('contact_hero_desc')}
          </p>
        </AnimatedSection>
        <AnimatedSection animation="fade-in" delay={0.2}>
          <div className="flex flex-wrap justify-center gap-8 text-sm">
            {badges.map(item => (
              <div key={item.labelKey} className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-slate-800 rounded-lg">
                  <i className={`${item.icon} text-cyan-400`}></i>
                </div>
                <div className="text-left">
                  <div className="text-white font-medium text-sm">{t(item.labelKey)}</div>
                  <div className="text-slate-400 text-xs">{t(item.subKey)}</div>
                </div>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
